// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2K8RG","signatureButtonsRight":"ModalSign_signatureButtonsRight__HhVZd"};